import React, { useState, useEffect, Fragment } from "react"
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import FormLabel from '@material-ui/core/FormLabel';
import { faSave } from '@fortawesome/free-solid-svg-icons'
import Menu from '@material-ui/icons/Menu';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { COLORS } from '../../styles/colors';
import { withStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const frequncyGaps = [
    {
        label: 'minutes',
        value: 'minutes'
    },
    {
      label: 'hours',
      value: 'hours'
    },
    {
        label: 'day(s)',
        value: 'day(s)'
    }, 
    {
      label: 'week(s)',
      value: 'week(s)'
    },
    {
      label: 'month(s)',
      value: 'month(s)'
    },
    {
      label: 'year(s)',
      value: 'years'
    }
  ]

const styles = theme => ({
    root: {
        "& .MuiInputBase-input": {
          height: "80px !important",
        },
      },
    textarea: {
      height: "100px !important"
    }
});



const StepMessage = withStyles(styles)(props => {

  const today = new Date()
  const { classes } = props;
  const [data, setData] = useState(props.data)
  
  const onChange = (evt) =>  {
    const { value, name } = evt.target
    setData({
        ...data,
        [name]: value
    })
  }

  const saveData = (evt) =>  {
    let condition = false;
    if (props.isWait) {
        condition = data.timeGap !== '' && data.frequncyGap !== ''
    } else {
        condition = data.message !== '';
    } 
    if (condition) {  
        props.onSave(data, props.stepIndex)
    }
  }

  return (
    <Fragment>
        { props.isWait ?
         <Grid container spacing={12}>
            <FormControl component="fieldset" style={{'marginTop': '10px'}}>
                <FormLabel component="legend">Wait For.</FormLabel>
            </FormControl>
            <Grid item xs={2} style={{'marginLeft': '5px'}}>
                <TextField
                label=""
                value={data.timeGap}
                margin="dense"
                variant="outlined"
                onChange={event => onChange(event)}
                name = "timeGap"
                InputProps={{
                    inputProps: { min: 1, max: 1000 } 
                }}
                type="number"
                inputProps={{ maxLength: 60 }}
                />
            </Grid>
            <Grid item xs={2} style={{'marginLeft': '5px'}}>
            <TextField
                label={""}
                InputLabelProps={{
                    shrink: true,
                }}
                value={data.frequncyGap}
                name="frequncyGap"
                margin="dense"
                variant="outlined"
                select
                onChange={event => onChange(event)}
            >
            {frequncyGaps && frequncyGaps.map(option => (
                <MenuItem key={option.value} value={option.value}>
                    {option.label}
                </MenuItem>
            ))}
        </TextField>
            </Grid>
            <Grid item xs={2} style={{'marginLeft': '10px', 'marginTop': '10px'}}>
            <FontAwesomeIcon 
                size="lg"
                onClick={() => saveData()} 
                icon={faSave} title={'Save'}
                style={{ marginRight: 5, color: COLORS.orange }}
             />
            </Grid>
        </Grid>
        :
        <Grid container spacing={12} style={{'marginTop': '5px'}}>
            <Grid item xs={5} style={{'marginLeft': '5px'}}>
                <TextField
                    InputProps={{
                        className: classes.textarea
                    }}
                    className={classes.root}
                    label="Message"
                    value={data.message}
                    multiline
                    rows={4}
                    name="message"
                    onChange={event => onChange(event)}
                    variant="outlined"
             
                />
            </Grid>
            <Grid item xs={2} style={{'marginLeft': '10px', 'marginTop': '40px'}}>
                <FontAwesomeIcon 
                    size="lg" 
                    onClick={() => saveData()} 
                    icon={faSave} title={'Save'}
                    style={{ marginRight: 5, color: COLORS.orange }}
                />
            </Grid>
        </Grid>
    }
    </Fragment>
  )
});

export default StepMessage;


// WEBPACK FOOTER //
// ./src/components/automations/StepMessage.js